import React from "react";
import { Link } from "react-router-dom";

export const SystemConfigNavbar = () => {
  return (
    <div className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box-two">
              <h4 className="page-title"></h4>
              <h1 className="welcome_text">SYSTEM CONFIGURATION</h1>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <nav
              className="navbar navbar-light navbar-expand-md bg-faded "
              style={{
                boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.075)",
              }}
            >
              <a href="/" className="navbar-brand d-flex"></a>
              <ul className="navbar-nav ml-auto justify-content-end">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/dashboard/system-configuration"
                    style={{
                      borderRight: "3px solid #243050",
                    }}
                  >
                    ROLES
                  </Link>
                </li>
                <li className="nav-item ml-auto">
                  <Link
                    className="nav-link"
                    to="/dashboard/system-configuration/jobtitle"
                    style={{
                      borderRight: "3px solid #243050",
                    }}
                  >
                    JOBTITLE
                  </Link>
                </li>
                <li className="nav-item ml-auto">
                  <Link
                    className="nav-link"
                    to="/dashboard/system-configuration/leave"
                    style={{
                      borderRight: "3px solid #243050",
                    }}
                  >
                    LEAVE
                  </Link>
                </li>
                <li className="nav-item ml-auto">
                  <Link
                    className="nav-link"
                    to="/dashboard/system-configuration/event"
                    style={{
                      borderRight: "3px solid #243050",
                    }}
                  >
                    EVENT CATEGORIES
                  </Link>
                </li>
                <li className="nav-item ml-auto">
                  <Link
                    className="nav-link"
                    to="/dashboard/system-configuration/subcategory"
                    style={{
                      borderRight: "3px solid #243050",
                    }}
                  >
                    REQUEST CATEGORIES
                  </Link>
                </li>
              </ul>
              <div className="navbar-collapse collapse" id="collapsingNavbar3">
                <ul className="nav navbar-nav ml-auto w-100 justify-content-end">
                  <li className="nav-item ml-auto"></li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/systemconfiguration/reusedcomponent/Navbar.js